const StockButton = () => {
    return(
        <>
            <a href="https://664b178a089caa8f14463f7b--venerable-sable-bc95ad.netlify.app/">
            <button style={{backgroundColor: "black", color: "yellow", marginLeft: "20px", marginTop: "20px", scale: "1", borderRadius: "10px", paddingLeft: "10px", paddingRight: "10px"}}>Latest Stock Prices</button>
            </a>
        </>
    )
}

export default StockButton;